module.exports = __webpack_public_path__ + "static/img/gaozhongyingyu.e53aa91d.jpg";